import styled from 'styled-components';

export const STitle = styled.div`
  font-size: 31px;
  text-align: center;
`; 